export default __webpack_public_path__ + "static/media/Advanced Contextual logo vertical.083d86d0.svg";